/**
 * @name escapeQuotes
 * @description Adds escape characters before double quotes in the given string
 */
export const escapeQuotes = (string: string): string =>
  string.replace(/"/g, '\\"');
